<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
* {
  margin: 0;
}
#app {
  height: 100vh;

  /* width: 100wh; */
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
/deep/ .el-table:before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
/deep/.el-input-group__append {
  border: 1px solid #409eff;
  background-color: #409eff;
  color: #ffffff;
}
/deep/.el-input-group__append > button {
  background-color: #409eff;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue